module.exports = __webpack_public_path__ + "img/vertical_4_4_0.de3c39e2.png";